export class SelectableItem {
  constructor(public item: string, public selected?: boolean, public id?: string) {
    if (selected === undefined) selected = false;
  }
}